require('./bootstrap')

import Swiper from 'swiper/bundle'

const rec_slider = new Swiper('.recomendations_slider', {
    slidesPerView: 1,
    spaceBetween: 20,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: '.recomendations_slider_wrapper .swiper-button-next',
        prevEl: '.recomendations_slider_wrapper .swiper-button-prev',
    },
    pagination: {
        el: '.recomendations_slider_wrapper .swiper-pagination',
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 20,
        },
        1200: {
            slidesPerView: 3,
            spaceBetween: 40,
        },
    },
})

;(function ($) {
    $(function () {
        $('html').addClass('js')

        initJSInstitutionCategoriesPage($);

        $('.header_toggler').on('click', function () {
            $(this).toggleClass('is-active')
            $('html').toggleClass('menu-open')
            return false
        })

        $('.header_search_toggler').on('click', function () {
            $(this).toggleClass('is-active')
            $('html').toggleClass('search-open')
            $('html').removeClass('menu-open')
            return false
        })

        $(document).on(
            'click',
            '.menu-open .app-wrapper, .search-open .app-wrapper',
            function (e) {
                if ($(e.target).hasClass('app-wrapper')) {
                    $('html').removeClass('menu-open search-open')
                }
            }
        )

        $('.accordion-title').on('click', function () {
            $(this).parent().toggleClass('is-active')
        })



        const showFirstInstitution = () => {
            const firstInstitution = $('.institutions_list li:first-child .institution_item');
            const type_id = firstInstitution.data('id')
            firstInstitution
                .addClass('is-active')
                .parent()
                .siblings()
                .find('.institution_item')
                .removeClass('is-active')
            $('.section_institutions').slideDown(300)
            $('.institution_group[data-id="' + type_id + '"]')
                .slideDown(300)
                .siblings()
                .slideUp(300)
        }

        $('#home-institution-anchor').on('click', showFirstInstitution);

        //institution
        $('.institution_item').on('click', function () {
            var type_id = $(this).data('id')
            $(this)
                .addClass('is-active')
                .parent()
                .siblings()
                .find('.institution_item')
                .removeClass('is-active')
            $('.section_institutions').slideDown(300)
            $('.institution_group[data-id="' + type_id + '"]')
                .slideDown(300)
                .siblings()
                .slideUp(300)


            $([document.documentElement, document.body]).animate(
                {
                    scrollTop: $('.section_institutions').offset().top - ($(window).width() <= 768 ? 150 : 360),
                },
                400
            )


            return false
        })

        // //institutions slider
        // $(
        //     '.institution_list .swiper-button-next, .institution_list .swiper-button-prev '
        // ).css('display', 'block')
        // $('.institution_list').each(function () {
        //     var institution_slider = new Swiper(
        //         '#' + $(this).attr('id') + ' .swiper',
        //         {
        //             slidesPerView: 1,
        //             spaceBetween: 15,
        //             navigation: {
        //                 nextEl:
        //                     '#' + $(this).attr('id') + ' .swiper-button-next',
        //                 prevEl:
        //                     '#' + $(this).attr('id') + ' .swiper-button-prev',
        //             },
        //             pagination: {
        //                 el: '#' + $(this).attr('id') + ' .swiper-pagination',
        //             },
        //             breakpoints: {
        //                 400: {
        //                     slidesPerView: 2,
        //                     spaceBetween: 15,
        //                 },
        //                 700: {
        //                     slidesPerView: 3,
        //                     spaceBetween: 20,
        //                 },
        //                 1000: {
        //                     slidesPerView: 4,
        //                     spaceBetween: 20,
        //                 },
        //                 1200: {
        //                     slidesPerView: 5,
        //                     spaceBetween: 25,
        //                 },
        //             },
        //         }
        //     )
        // })

        // Sticky
        window.onscroll = function () {
            StickyHeader()
        }
        //header
        var header = document.querySelector('.header'),
            header_wrap = document.querySelector('.app-wrapper'),
            sticky = header.offsetTop,
            fake_header = document.createElement('div')
        // fake_header.style.height = header.offsetHeight + 'px'
        // fake_header.style.display = 'none'
        header_wrap.insertBefore(fake_header, header.nextSibling)

        //course header
        var course_header = document.querySelector('.course_page_header'),
            course_wrap = document.querySelector('.course_page_wrap')
        if (course_header) {
            var course_header_sticky =
                    course_header.offsetTop + course_header.offsetHeight,
                fake_course_header = document.createElement('div')
            fake_course_header.className = 'course_header_placeholder'
            fake_course_header.style.height = course_header.offsetHeight + 'px'
            fake_course_header.style.display = 'none'

            course_wrap.insertBefore(
                fake_course_header,
                course_header.nextSibling
            )
        }

        StickyHeader()
        function StickyHeader() {
            if (window.pageYOffset > sticky) {
                header_wrap.classList.add('sticky')
                fake_header.style.display = 'block'
            } else {
                header_wrap.classList.remove('sticky')
                fake_header.style.display = 'none'
            }
            if (course_header && window.innerWidth > 1200) {
                if (window.pageYOffset > course_header_sticky) {
                    course_header.style.top = header.offsetHeight + 'px'
                    header_wrap.classList.add('course_sticky')
                    fake_course_header.style.display = 'block'
                    console.log(fake_course_header)
                } else {
                    course_header.style.top = 0
                    header_wrap.classList.remove('course_sticky')
                    fake_course_header.style.display = 'none'
                }
            }
        }

        //course preview
        $('.category_course_item_preview[data-toggle=popover]').popover({
            html: true,
            sanitize: false,
            content: function () {
                var content_id = $(this).data('popover-id')
                return $('#' + content_id).html()
            },
        })
        $('body').on('click', function (e) {
            if (
                $(e.target).data('toggle') !== 'popover' &&
                $(e.target).parents('.popover.show').length === 0
            ) {
                $('[data-toggle="popover"]').popover('hide')
            }
        })

        //video preview
        $(document).on('click', '.video_play', function () {
            var video = $(this).siblings('video')
            $(this).hide()
            video.prop('controls', true)
            video[0].play()

            return false
        })

        //course accordion
        $('.course_episode_header').on('click', function () {
            $(this)
                .toggleClass('is-active')
                .parent()
                .siblings()
                .find('.course_episode_header')
                .removeClass('is-active')
            $(this)
                .next('.course_episode_content')
                .slideToggle(300)
                .parent()
                .siblings()
                .find('.course_episode_content')
                .slideUp(300)
            return false
        })

        //preload gif images
        var images = new Array(),
            preloadImagsea = new Array()
        function preload(img) {
            for (i = 0; i < img.length; i++) {
                preloadImagsea[i] = new Image()
                preloadImagsea[i].src = img[i]
            }
        }
        $('.institution_ico img').each(function () {
            images.push($(this).attr('data-hover'))
        })
        preload(images)

        //gif animation on hover
        $('.institution_item, .institution_item_1').hover(function () {
            var img = $(this).find('.institution_ico img'),
                img_src = img.attr('src'),
                img_hover = img.data('hover')
            if (img_hover && $(window).width() > 1024) {
                img.attr('src', img_hover)
                img.data('hover', img_src)
            }
        })
    })

    // password toggler
    $('.password-toggle').click(function () {
        if ($(this).hasClass('password-toggle-hidden')) {
            $(this)
                .removeClass('password-toggle-hidden')
                .addClass('password-toggle-visible')
            $(this).siblings('.form-control').attr('type', 'text')
        } else {
            $(this)
                .removeClass('password-toggle-visible')
                .addClass('password-toggle-hidden')
            $(this).siblings('.form-control').attr('type', 'password')
        }
    })
})(jQuery)

//faq
var acc = document.getElementsByClassName('faq-question')
var i

for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function () {
        this.classList.toggle('active')
        var panel = this.nextElementSibling
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null
        } else {
            panel.style.maxHeight = panel.scrollHeight + 'px'
        }
    }
}

function initJSInstitutionCategoriesPage($) {
    const page = $('#institution-categories');
    if (page) {
        let activeCourseId = null;
        let activeCourse = page.find('#institution-title');
        const courses = page.find('.institution_box_title');
        const links = page.find('.institution_box_more a');
        const cardMap = {}

        const changeActive = (nv, ov, id) => {
            const activeCourses = [];
            activeCourseId = id;
            activeCourse = nv;
            ov.removeClass('active');
            nv.addClass('active');

            const key = id ? `course-${id}-institution` : null;

            links.addClass('hidden');

            if (key) {
                page.find(`.institution_box_more a#institution-${id}-more`).removeClass('hidden');

                Object.entries(cardMap).forEach(([insId, cards]) => {
                    if (key === `course-${insId}-institution`) {
                        cards.removeClass('hidden')
                    } else {
                        cards.addClass('hidden')
                    }
                })
            } else {
                Object.entries(cardMap).forEach(([_, cards]) => {
                    cards.toArray().forEach((tag) => {
                        if (!activeCourses.includes(tag.dataset.courseId)) {
                            activeCourses.push(tag.dataset.courseId);
                            tag.classList.remove('hidden');
                        } else {
                            tag.classList.add('hidden')
                        }
                    });
                })
            }
        };

        courses.toArray().forEach((item) => {
            if (item.dataset.insId) {
                cardMap[item.dataset.insId] = page.find(`.institution_box_content #course-${item.dataset.insId}-institution`)
            }
            item.addEventListener('click', () => {
                if (activeCourseId !== item.dataset.insId) {
                    changeActive($(item), activeCourse, item.dataset.insId);
                }
            })
            item.addEventListener('mouseenter', () => {
                if (activeCourseId !== item.dataset.insId) {
                    changeActive($(item), activeCourse, item.dataset.insId);
                }
            })
        })

        changeActive(activeCourse, activeCourse, null);
    }
}
